import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import moment from 'moment'

export enum MasterCampaignPlanCreateStep {
  SetUrl = 'SetUrl',
  SetBudget = 'SetBudget',
  SetStartDateAndDuration = 'SetStartDateAndDuration',
  AddAdditionalDetails = 'AddAdditionalDetails'
}

export interface CreateMasterCampaignPlanState {
  step: MasterCampaignPlanCreateStep
  url: string
  aiRecommendedBudget: boolean
  targetMonthlyBudget?: number
  maxSingleBudget?: number
  aiRecommendedStartAndDuration: boolean
  startDate: string
  durationInMonths: number
  details: string
}

const initialState: CreateMasterCampaignPlanState = {
  step: MasterCampaignPlanCreateStep.SetUrl,
  url: '',
  aiRecommendedBudget: true,
  targetMonthlyBudget: undefined,
  aiRecommendedStartAndDuration: true,
  startDate: moment().add(1, 'month').format('MM/DD/YYYY'),
  durationInMonths: 12,
  details: ''
}

const createMasterCampaignPlan = createSlice({
  name: 'createMasterCampaignPlan',
  initialState,
  reducers: {
    setStep(state: CreateMasterCampaignPlanState, { payload }: PayloadAction<MasterCampaignPlanCreateStep>) {
      state.step = payload
    },
    setUrl(state: CreateMasterCampaignPlanState, { payload }: PayloadAction<string>) {
      state.url = payload
    },
    setAiRecommendedBudget(state: CreateMasterCampaignPlanState, { payload }: PayloadAction<boolean>) {
      state.aiRecommendedBudget = payload
    },
    setTargetMonthlyBudget(state: CreateMasterCampaignPlanState, { payload }: PayloadAction<number>) {
      state.targetMonthlyBudget = payload
    },
    setMaxSingleBudget(state: CreateMasterCampaignPlanState, { payload }: PayloadAction<number>) {
      state.maxSingleBudget = payload
    },
    setAiRecommendedStartAndDuration(state: CreateMasterCampaignPlanState, { payload }: PayloadAction<boolean>) {
      state.aiRecommendedStartAndDuration = payload
    },
    setStartDate(state: CreateMasterCampaignPlanState, { payload }: PayloadAction<moment.Moment>) {
      state.startDate = payload.format('MM/DD/YYYY')
    },
    setDurationInMonths(state: CreateMasterCampaignPlanState, { payload }: PayloadAction<number>) {
      state.durationInMonths = payload
    },
    setDetails(state: CreateMasterCampaignPlanState, { payload }: PayloadAction<string>) {
      state.details = payload
    },
    reset(state: CreateMasterCampaignPlanState) {
      state.step = initialState.step
      state.url = initialState.url
      state.aiRecommendedBudget = initialState.aiRecommendedBudget
      state.targetMonthlyBudget = initialState.targetMonthlyBudget
      state.maxSingleBudget = initialState.maxSingleBudget
      state.aiRecommendedStartAndDuration = initialState.aiRecommendedStartAndDuration
      state.startDate = initialState.startDate
      state.durationInMonths = initialState.durationInMonths
      state.details = initialState.details
    },
    resetWithUrl(state: CreateMasterCampaignPlanState, { payload }: PayloadAction<string>) {
      state.step = initialState.step
      state.url = payload
      state.aiRecommendedBudget = initialState.aiRecommendedBudget
      state.targetMonthlyBudget = initialState.targetMonthlyBudget
      state.maxSingleBudget = initialState.maxSingleBudget
      state.aiRecommendedStartAndDuration = initialState.aiRecommendedStartAndDuration
      state.startDate = initialState.startDate
      state.durationInMonths = initialState.durationInMonths
      state.details = initialState.details
    }
  }
})

export const { setStep, setAiRecommendedBudget, setTargetMonthlyBudget, setMaxSingleBudget, setAiRecommendedStartAndDuration, setStartDate, setDurationInMonths, setDetails, setUrl, reset, resetWithUrl } = createMasterCampaignPlan.actions

export default createMasterCampaignPlan.reducer
